"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAnswers = useAnswers;
const react_1 = require("react");
const stores_1 = require("../stores/index.js");
const view_models_1 = require("../../view-models/index.js");
function useAnswers() {
    const answers = (0, stores_1.useAnswersStore)((state) => state.answers);
    const setAnswer = (0, stores_1.useAnswersStore)((state) => state.setAnswer);
    const clearAnswers = (0, stores_1.useAnswersStore)((state) => state.clearAnswers);
    return (0, react_1.useMemo)(() => (0, view_models_1.answersViewModel)(answers, setAnswer, clearAnswers), [answers, setAnswer, clearAnswers]);
}
